// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"405915ba","355":"a72c19fd","450":"4306bc0d","453":"e5069871"}[chunkId] + ".chunk.js";
};